// CB:BEGIN admin-audit-logs-page
/**
 * Admin Audit Logs Page
 * Displays comprehensive audit trail viewer for admin oversight
 */
import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { AuditLogViewer } from '../../components/admin/AuditLogViewer';

export default function AdminAuditLogsPage() {
  return (
    <AdminLayout title="Audit Logs">
      <AuditLogViewer />
    </AdminLayout>
  );
}
// CB:END admin-audit-logs-page
